import type { ParticipationReportGridColDef, ParticipationReportRecord } from '../../types';
import { IssuerCellRenderer } from './IssuerCellRenderer';

export type Value = ParticipationReportRecord['issuerName'];

export const issuerColDef: ParticipationReportGridColDef<Value> = {
  field: 'issuerName',
  headerName: 'Issuer',
  filter: 'agTextColumnFilter',
  pinned: 'left',
  width: 249,
  cellRenderer: IssuerCellRenderer,
  lockPinned: true,
  lockPosition: true,
  lockVisible: true,
  floatingFilter: true,
};
